<template>
  <div class="mIndex">
    <!-- 全局加载遮罩 -->
    <div v-if="globalLoading" class="global-loading-mask">
      <div class="loading-spinner"></div>
    </div>
    <div class="menuWrap">
      <img class="logo" src="@/assets/images/logo.png" alt="logo" />
      <img
        class="annualPackage"
        src="@/assets/images/annualPackage.png"
        alt="annualPackage"
        @click="goPackage"
      />
    </div>
    <!-- 轮播图容器（紧跟menuWrap下方） -->
    <div
      class="swiperWrap"
      v-if="homeVo.bannerList && homeVo.bannerList.length"
    >
      <swiper :options="swiperOptions" class="bannerSwiper">
        <!-- 轮播图项：动态渲染接口返回的轮播图 -->
        <swiper-slide v-for="(item, idx) in homeVo.bannerList" :key="idx">
          <img :src="item.img" alt="轮播图" class="bannerImg" />
        </swiper-slide>

        <!-- 轮播指示器（小圆点） -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="countWrap">
      <div class="countItem">
        <span class="title">平台用户</span>
        <span class="num">{{ targetUsers }}+</span>
      </div>
      <div class="countItem">
        <span class="title">活动场次</span>
        <span class="num">{{ targetEvents }}+</span>
      </div>
      <div class="countItem">
        <span class="title">参与人数</span>
        <span class="num">{{ targetParticipants }}+</span>
      </div>
    </div>
    <!-- 适用场景 -->
    <div class="sceneWrap">
      <div class="title">适用场景</div>
      <div class="subTitle">不一样的场合，一样的精彩</div>
      <div class="sceneType">
        <div
          class="typeItem"
          :class="{ active: activeTypeIdx === idx }"
          @click="handleSelectType(item, idx)"
          v-for="(item, idx) in homeVo.liveTypeList"
          :key="idx"
        >
          {{ item.typeName }}
        </div>
      </div>
      <!-- 场景内容加载遮罩 -->
      <div
        class="sceneContent"
        :style="{ position: 'relative', minHeight: '200px' }"
      >
        <div v-if="sceneLoading" class="scene-loading">
          <div class="mini-spinner"></div>
        </div>
        <img
          :src="item.img"
          v-for="(item, idx) in homeVo.sceneList"
          :key="idx"
          alt="轮播图"
        />
      </div>
    </div>
    <!-- 嗨动优势 -->
    <div class="sceneWrap">
      <div class="title">嗨动优势</div>
      <div class="subTitle">坚持以用户为中心，追求卓越，永不止步</div>
      <div class="advantage">
        <img src="@/assets/images/advantage1.png" alt="嗨动优势1" />
        <img src="@/assets/images/advantage2.png" alt="嗨动优势2" />
        <img src="@/assets/images/advantage3.png" alt="嗨动优势3" />
        <img src="@/assets/images/advantage4.png" alt="嗨动优势4" />
      </div>
    </div>
    <!-- 功能简介 -->
    <div class="sceneWrap">
      <div class="title">功能简介</div>
      <div class="subTitle">超多游戏现场互动，嗨爆全场</div>
      <div class="sceneContent">
        <img
          :src="item.img"
          v-for="(item, idx) in homeVo.functionList"
          :key="idx"
          alt="轮播图"
        />
      </div>
    </div>
    <!-- 经典案例 -->
    <div class="sceneWrap">
      <div class="title">经典案例</div>
      <div class="subTitle">不一样的场合，一样的精彩</div>
      <div class="sceneContent">
        <img
          :src="item.img"
          v-for="(item, idx) in homeVo.caseList"
          :key="idx"
          alt="轮播图"
        />
      </div>
    </div>
    <!-- 合作单位 -->
    <div class="sceneWrap">
      <div class="title">合作单位</div>
      <div class="unitContent">
        <img src="@/assets/images/customer1.png" alt="客户1" />
        <img src="@/assets/images/customer2.png" alt="客户2" />
        <img src="@/assets/images/customer3.png" alt="客户3" />
        <img src="@/assets/images/customer4.png" alt="客户4" />
        <img src="@/assets/images/customer5.png" alt="客户5" />
        <img src="@/assets/images/customer6.png" alt="客户6" />
        <img src="@/assets/images/customer7.png" alt="客户7" />
        <img src="@/assets/images/customer8.png" alt="客户8" />
        <img src="@/assets/images/customer9.png" alt="客户9" />
        <img src="@/assets/images/customer10.png" alt="客户10" />
        <img src="@/assets/images/customer11.png" alt="客户11" />
        <img src="@/assets/images/customer12.png" alt="客户12" />
      </div>
    </div>
    <!-- 平台用户 -->
    <div class="sceneWrap">
      <div class="title">平台用户</div>
      <div class="subTitle">感谢每一位的付出</div>
      <star-user />
    </div>
    <!-- 服务与支持 -->
    <div class="bottomWrap">
      <span class="title">服务与支持</span>
      <span class="label" style="margin-top: 8px"
        >嗨动互动是一款为各类活动设计的大屏互动软件，平台提供签到、投票、问答、抽奖、游戏等多种互动形式，科技赋能活动的参与度和趣味性。适用于企业年会、商务会议、促销活动、新品发布、婚礼庆典、生日聚会等场景。嗨动互动—引领互动新风尚！</span
      >
      <div style="margin: 20px 0">
        <span class="title">嗨动互动</span> <span class="link">隐私政策</span>
        <span class="link">用户协议</span>
      </div>
      <div class="flexCenter">
        <span class="label"
          >©2016-2020上海原擎网络科技有限公司.版权所有 ICP证:</span
        >
        <div class="link">沪ICP备16024705号</div>
      </div>
      <div class="flexCenter">
        <div>
          <img
            src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png"
            alt="公安"
          />
        </div>
        <div class="link">沪公网安备 31010502006630号</div>
      </div>
      <span style="margin-top: 44px" class="title">热线：400-108-1516</span>
      <span class="label"
        >公司地址：上海市静安区共和新路2993号（ 和源·中环企业广场 ）1215室</span
      >
    </div>
    <!-- 导航按钮 -->
    <div class="goTop" @click="goToTop">
      <img src="@/assets/images/icon_2top.png" alt="回到顶部"/>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import starUser from "./starUser";

export default {
  name: "index",
  components: { Swiper, SwiperSlide, starUser },
  data() {
    return {
      activeTypeIdx: 0,
      homeVo: {},
      indexVo: {},
      targetUsers: 127707,
      targetEvents: 12087896,
      targetParticipants: 182631452,
      globalLoading: false, // 全局加载状态
      sceneLoading: false, // 场景列表加载状态
      swiperOptions: {
        direction: "horizontal",
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        mousewheel: false,
        speed: 500,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoWidth: false,
        autoHeight: false,
      },
    };
  },
  created() {
    this.loadAllData();
  },
  methods: {
    // 新增：回到顶部核心方法
    goToTop() {
      // 平滑滚动到页面顶部，x轴0，y轴0
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },
    goPackage(){
      this.$router.push("/annualPackage");
    },
    // 新增：typeItem点击事件 - 核心逻辑
    handleSelectType(item, idx) {
      if (this.activeTypeIdx === idx) return;
      this.activeTypeIdx = idx;
      this.getSelectData(item);
    },

    // 新增：选中后的请求方法
    async getSelectData(selectItem) {
      console.log("选中的分类数据", selectItem);
      this.sceneLoading = true;
      try {
        const res = await this.$http.get("/emcee-api/website/wsiteScene", {
          params: { liveTypeId: selectItem.id },
        });
        console.log("分类选中请求成功", res.data);
        this.homeVo.sceneList = res.data;
      } catch (err) {
        console.error("分类选中请求失败", err);
      } finally {
        this.sceneLoading = false;
      }
    },

    // 修改：合并两个接口的加载
    async loadAllData() {
      this.globalLoading = true;

      try {
        // 使用Promise.all同时发起两个请求
        const [homeRes, countRes] = await Promise.all([
          this.$http.get("/emcee-api/website/wsite_home"),
          this.$http.get("/jweb-api/count/index"),
        ]);

        // 分别处理两个请求的结果
        this.homeVo = homeRes.data;
        this.indexVo = countRes.data;
        this.targetUsers = countRes.data.emceeUserCount+83572;
        this.targetEvents = countRes.data.liveCount+11576947;
        this.targetParticipants = countRes.data.userCount+173091999;

        console.log("首页数据:", this.homeVo);
        console.log("统计数据:", this.indexVo);
      } catch (err) {
        console.error("数据请求失败", err);
        // 这里可以添加错误提示
      } finally {
        this.globalLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.mIndex {
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-right: 0 !important;
  overflow-x: hidden;
  background-color: #fff;
  position: relative;

  /* 全局加载遮罩 */
  .global-loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #eb698f;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  /* 场景内容加载遮罩 */
  .scene-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  .mini-spinner {
    width: 24px;
    height: 24px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #eb698f;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .menuWrap {
    width: 357px;
    height: 40px;
    margin: 10px;
    display: flex;
    justify-content: space-between;

    .logo {
      width: 72px;
      height: 25px;
      margin-top: 5px;
      margin-left: 21px;
    }

    .annualPackage {
      width: 52px;
      height: 28px;
      margin-top: 2px;
      margin-right: 24px;
    }
  }

  .swiperWrap {
    width: 100%;
    height: 180px;
    margin: 10px 0;
    overflow: hidden;

    .bannerSwiper {
      width: 100%;
      height: 100%;
    }

    .bannerImg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .countWrap {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 28px;
    color: #fff;
    width: 100%;
    font-size: 12px;
    font-weight: 400;

    .countItem {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 101px;
      height: 47px;
      border-radius: 3px;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);

      .title {
        width: 65px;
        height: 14px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 7px;
        font-size: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 2px;
      }
    }

    & > *:nth-child(1) {
      background: #07b99b;
    }

    & > *:nth-child(2) {
      background: #f68f20;
    }

    & > *:nth-child(3) {
      background: #4984fd;
    }
  }

  .sceneWrap {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-top: 41px;

    .title {
      font-weight: 600;
      font-size: 20px;
      color: #333333;
    }

    .subTitle {
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }

    .sceneType {
      width: 307px;
      height: 34px;
      background: #ffffff;
      box-shadow: 0 4px 8px 0 rgba(235, 105, 143, 0.25);
      border-radius: 17px 17px 17px 17px;
      border: 1px solid #fceaee;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-top: 20px;

      .typeItem {
        width: 82px;
        height: 34px;
        border-radius: 17px 17px 17px 17px;
        display: flex;
        justify-content: center;
        align-items: center;

        &.active {
          background: #eb698f;
          color: #fff;
          box-shadow: 0 2px 4px rgba(255, 77, 79, 0.3);
        }
      }
    }

    .unitContent {
      margin-top: 24px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(4, 1fr);
      width: 100%;
      box-sizing: border-box;

      img {
        width: 99px;
        height: 99px;
        border-radius: 3px;
        object-fit: cover;
        background-color: #fff;
      }
    }

    .advantage {
      margin-top: 24px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 12px;
      width: 100%;
      box-sizing: border-box;

      img {
        width: 152px;
        height: 180px;
        border-radius: 3px;
        object-fit: cover;
      }
    }

    .sceneContent {
      margin-top: 24px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(4, 1fr);
      gap: 16px;
      width: 100%;
      box-sizing: border-box;

      img {
        width: 150px;
        height: 84px;
        object-fit: cover;
        border-radius: 4px;
      }
    }
  }

  .bottomWrap {
    width: 100%;
    box-sizing: border-box;
    background-color: #2a303b;
    padding: 24px 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .title {
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }

    .label {
      font-weight: 400;
      font-size: 9px;
      color: #999999;
      line-height: 13px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .link {
      font-weight: 400;
      font-size: 9px;
      color: #1990ff;
      line-height: 13px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }

  // 新增：回到顶部按钮样式 - 满足48X48、右侧固定、垂直居中
  .goTop {
    position: fixed;
    right: 11px; // 右侧完全靠边
    top: 70%; // 垂直居中基准
    transform: translateY(-50%); // 向上偏移自身50%，实现精准垂直居中
    z-index: 999; // 遮挡层级（低于全局加载的9999，避免遮挡加载层）
    cursor: pointer; // 鼠标悬浮手型，提升交互体验

    img {
      width: 48px;
      height: 48px;
      object-fit: contain; // 防止图片拉伸变形
    }
    // 可选：点击反馈，提升交互体验
    &:active {
      opacity: 0.8;
      transform: translateY(-50%) scale(0.95);
    }
  }

  .flexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

// 轮播样式
::v-deep .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: #ccc;
  opacity: 1;
}

::v-deep .swiper-pagination-bullet-active {
  background: #ff4d4f;
}

::v-deep .swiper-pagination {
  bottom: 10px !important;
}
</style>
